import type { DailyBlotterQuote, Filters, PageInfo } from './dailyBlotter.model';

export type DailyBlotterActions =
  | DailyBlotterPageChanged
  | DailyBlotterQuotesReceived
  | DailyBlotterQuotesRequested
  | DailyQuotesRequestFailed
  | DailyBlotterColumnsRequested
  | DailyBlotterColumnsRequestFailed
  | DailyBlotterColumnsReceived
  | DailyBlotterItemsPerPageChanged
  | DailyBlotterFiltersUpdated;

//// QUOTES REQUESTED
export function dailyBlotterQuotesRequested(pageIndex: number) {
  return { type: 'DAILY_BLOTTER_QUOTES_REQUESTED' as const, pageIndex };
}
export type DailyBlotterQuotesRequested = ReturnType<typeof dailyBlotterQuotesRequested>;

//// FAILED
export function dailyQuotesRequestFailed() {
  return { type: 'DAILY_BLOTTER_QUOTES_REQUEST_FAILED' as const };
}
export type DailyQuotesRequestFailed = ReturnType<typeof dailyQuotesRequestFailed>;

//// RECEIVED
export function dailyBlotterQuotesReceived(quotes: readonly DailyBlotterQuote[], pageInfo: PageInfo) {
  return { type: 'DAILY_BLOTTER_QUOTES_RECEIVED' as const, quotes, pageInfo };
}
export type DailyBlotterQuotesReceived = ReturnType<typeof dailyBlotterQuotesReceived>;

//// COLUMNS REQUESTED
export function dailyBlotterColumnsRequested() {
  return { type: 'DAILY_BLOTTER_COLUMNS_REQUESTED' as const };
}
export type DailyBlotterColumnsRequested = ReturnType<typeof dailyBlotterColumnsRequested>;

//// COLUMNS REQUESTED FAILED
export function dailyBlotterColumnsRequestFailed() {
  return { type: 'DAILY_BLOTTER_COLUMNS_REQUESTT_FAILED' as const };
}
export type DailyBlotterColumnsRequestFailed = ReturnType<typeof dailyBlotterColumnsRequestFailed>;

///// COLUMNS RECEIVED

export function dailyBlotterColumnsReceived(columns: any) {
  return { type: 'DAILY_BLOTTER_COLUMNS_RECEIVED' as const, columns };
}
export type DailyBlotterColumnsReceived = ReturnType<typeof dailyBlotterColumnsReceived>;

/// PAGE CHANGED
export function dailyBlotterPageChanged(pageIndex: number) {
  return { type: 'DAILY_BLOTTER_PAGE_CHANGED' as const, pageIndex };
}
export type DailyBlotterPageChanged = ReturnType<typeof dailyBlotterPageChanged>;

//// ITEM PER PAGE
export interface DailyBlotterItemsPerPageChanged {
  type: 'DAILY_BLOTTER_ITEMS_PER_PAGE_CHANGED';
  itemsPerPage: number;
  page: number;
}
export function dailyBlotterItemsPerPageChanged(itemsPerPage: number, page: number): DailyBlotterItemsPerPageChanged {
  return {
    type: 'DAILY_BLOTTER_ITEMS_PER_PAGE_CHANGED',
    itemsPerPage,
    page,
  };
}

///// FILTERS UPDATED
export function dailyBlotterFiltersUpdated(filters: Filters) {
  return { type: 'DAILY_BLOTTER_FILTERS_UPDATED' as const, filters };
}

export type DailyBlotterFiltersUpdated = ReturnType<typeof dailyBlotterFiltersUpdated>;
